import { combinedLanguageCharacterSet } from "./language-character-set";

// period, apostrophe, hyphen, forward slash, space
const allowedNameSpecialChars = `\\-/' .`;

/*
    /^(?=.{1,30}$)[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻżÁáČčĎďÉéĚěÍíŘřŠšŤťÚúŮůÝýŽžÄäÖöÜüẞßÀàÂâÆæÇçÉéÈèÊêËëÎîÏïÔôŒœÙùÛûÜüŸÿÀàÈèÉéÌìÒòÓóÙùÇçÁáÉéÍíÑñÓóÚúÜüÇçĞğİıÖöŞşÜüÆæØøÅå\-/' .]+$/u
*/
export const nameValidationPattern = new RegExp(
  `^(?=.{1,30}$)[${combinedLanguageCharacterSet}${allowedNameSpecialChars}]+$`,
  "u",
);
